module.exports = __webpack_public_path__ + "static/media/editable-pencil.3f50494b.svg";